<template>
  <div>
    <home_head></home_head>           
    <div class="wai">

      <div class="zuoce">
            <!-- 网名 -->
            <div class="mingziyi">
              <img  v-if="auth_img == null"  src="../../../assets/home/yixiaoxing_head.png">
              <img  v-else-if="auth_img.slice(0,5) != 'https'" :src="url + '/storage/' + auth_img">
              <img  v-else-if="auth_img.slice(0,5) == 'https'" :src="auth_img">
              <span>{{auth_username}}</span>
            </div>

            <!-- 搜索框 -->
            <div class="chazhao">
              <button><span class="el-icon-search"></span></button>
              <input type="text" placeholder="输入关键字" v-model="keyWord"/>
            </div>

            <!-- 列表 -->
            <div class="liebiao" >
              <ul v-for="(item,index) in liebiao_list_new" :key="index" :class="{xuanzhong:index == bianlan}">
                <li v-if="data_id == item.member_a && data_id != item.member_b " @click="liebiao(item.member_b,item.member_a,index)" >
                  <div class="tishi" v-if="item.unread_total "></div>
                  <div class="touxiang">
                    <img v-if="item.avatar_b == null" src="../../../assets/home/yixiaoxing_head.png">
                    <img v-else-if="item.avatar_b.slice(0,5) != 'https'"  :src="liebiao_url + '/storage/' +item.avatar_b">
                    <img v-else-if="item.avatar_b.slice(0,5) == 'https'" :src="item.avatar_b">
                  </div>
                  <span class="yonghuming">{{item.name_b | ellipsis}}</span><br/>
                  <span class="xiaoxi" v-if = "item.last_msg_type == 'text'">{{item.last_msg | ellipsis}}</span>
                  <span class="xiaoxi" v-else-if = "item.last_msg_type == 'img' ">[图片]</span>
                  <span class="xiaoxi" v-else-if = "item.last_msg_type == 'video' ">[视频]</span>
                  <span class="xiaoxi" v-else-if = "item.last_msg_type == 'audio' ">[音频]</span>
                  <div class="shijian">{{shijian(item.last_msg_time)}}</div>
                </li>

                <li v-else  @click="liebiao(item.member_a,item.member_b,index)">
                  <div class="tishi" v-if="item.unread_total "></div>
                  <div class="touxiang">
                    <img v-if="item.avatar_a == null" src="../../../assets/home/yixiaoxing_head.png">
                    <img v-else-if="item.avatar_a.slice(0,5) != 'https'"  :src="liebiao_url + '/storage/' +item.avatar_a">
                    <img v-else-if="item.avatar_a.slice(0,5) == 'https'" :src="item.avatar_a">
                  </div>
                  <span class="yonghuming">{{item.name_a  | ellipsis}}</span><br />
                  <span class="xiaoxi" v-if = "item.last_msg_type == 'text'">{{item.last_msg | ellipsis}}</span>
                  <span class="xiaoxi" v-else-if = "item.last_msg_type == 'img' ">[图片]</span>
                  <span class="xiaoxi" v-else-if = "item.last_msg_type == 'video' ">[视频]</span>
                  <span class="xiaoxi" v-else-if = "item.last_msg_type == 'audio' ">[音频]</span>
                  <div class="shijian">{{shijian(item.last_msg_time)}}</div>
                </li>
              </ul>
            </div>
      </div>


      <!-- 聊天室 -->
      <div class="youce">

        <!-- 今日接待 -->
        <div class="jiedai" @click="fanhui">
          <span class="zuo">今日接待: {{liebiao_list.length}}</span>
          <span class="you">x</span>
        </div>

        <!-- 对方用户名 -->
        <div class="mingzier">
          <span v-if="userinfo_name == null || userinfo_name == ''">暂无用户名</span>
          <span v-else>{{userinfo_name}}</span>
        </div>

        <div class="liaotian" ref="msg-box">
           <!-- 聊天框历史记录 -->
          <div v-for="(item,index) in list_history" :key="index" class="content_list">
              <div class="content_av" style="width: 100%">
                  <div v-if="item.member_id != me_id">
                      <img class="img" v-if="userinfo_avatar == null || userinfo_avatar == ''" :src="userinfo_avatar1">
                      <img class="img" v-else-if="userinfo_avatar.slice(0,5) != 'https'" :src="url + '/storage/' + userinfo_avatar">
                      <img class="img" v-else-if="userinfo_avatar.slice(0,5) == 'https'" :src="userinfo_avatar">
                      <img class="img" v-else src="../../../assets/home/yixiaoxing_head.png">
                      <div class="span_time">{{ item.create_at }}</div>
                      <div class="content_message">
                          <div v-if="item.msg_type === 'text' || item.msg_type ===''">{{ item.msg }}</div>
                          <div v-else-if="item.msg_type === 'img'">
                            <el-image 
                              :src="url + '/storage/' + item.msg_url" 
                              style="width: 100px; height: 100px"
                              :preview-src-list = "[url + '/storage/' + item.msg_url]"
                              >
                              </el-image>
                          </div>
                          <div v-else-if="item.msg_type === 'video'">
                            <video  width="100%" height="100%" controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true">
                              <source :src="url + '/storage/' + item.msg_url" type="video/mp4">
                            </video>
                          </div>
                          <div v-else-if="item.msg_type === 'audio'" style="while:100px; height: 40px; ">
                            <audio   controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true">
                              <source :src="url + '/storage/' + item.msg_url" type="audio/mp3">
                            </audio>
                          </div>
                      </div>
                  </div>
                  <div v-else>
                      <img  class="img1"  v-if="auth_img == null"  src="../../../assets/home/yixiaoxing_head.png">
                      <img  class="img1"  v-else-if="auth_img.slice(0,5) != 'https'" :src="url + '/storage/' + auth_img">
                      <img  class="img1"  v-else-if="auth_img.slice(0,5) == 'https'" :src="auth_img">
                      <div class="span_time1">{{ item.create_at }}</div>
                      <div class="content_message1">
                          <div v-if="item.msg_type === 'text' || item.msg_type ==='' ">{{ item.msg }}</div>
                          <div v-else-if="item.msg_type === 'img'">
                            <el-image  
                              :src="url + '/storage/' + item.msg_url" 
                              style="width: 100px; height: 100px"
                              :preview-src-list = "[url + '/storage/' + item.msg_url]"
                            >
                            </el-image>
                          </div>
                          <div v-else-if="item.msg_type === 'video'">
                            <video  width="100%" height="100%" controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true">
                              <source :src="url + '/storage/' + item.msg_url" type="video/mp4">
                            </video>
                          </div>
                          <div v-else-if="item.msg_type === 'audio'">
                            <audio  controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true">
                              <source :src="url + '/storage/' + item.msg_url" type="audio/mp3">
                            </audio>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          
          <!-- 聊天框新消息 -->
          <div v-for="(item,index) in list" :key="index+10000" class="content_list2" >
              <div class="content_av2" style="width: 100%" v-if="item.chat_id == liebiao_list[bianlan].id " >
                  <div v-if="item.member_id == me_id">
                      <img class="img2" v-if="auth_img == null"  src="../../../assets/home/yixiaoxing_head.png">
                      <img class="img2" v-else-if="auth_img.slice(0,5) != 'https'" :src="url + '/storage/' + auth_img">
                      <img class="img2" v-else-if="auth_img.slice(0,5) == 'https'" :src="auth_img">
                      <span class="span_time2">{{ item.create_at }}</span>
                      <div class="content_message2">
                          <div v-if="item.msg_type === 'text' || item.msg_type ==='' ">{{ item.messages }}</div>
                          <div v-else-if="item.msg_type === 'img'">
                            <el-image  
                            :src="url + '/storage/' + item.msg_url" 
                            style="width: 100px; height: 100px"
                            :preview-src-list = "[url + '/storage/' + item.msg_url]"
                            >
                           </el-image>
                          </div>
                          <div v-else-if="item.msg_type === 'video'">
                            <video  width="100%" height="100%" controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true">
                              <source :src="url + '/storage/' + item.msg_url" type="video/mp4">
                            </video>
                          </div>
                          <div v-else-if="item.msg_type === 'audio'">
                            <audio   width="100" height="40" controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true">
                              <source :src="url + '/storage/' + item.msg_url" type="audio/mp3">
                            </audio>
                          </div>
                      </div>
                  </div>
                  <div v-else>
                      <img class="img3" v-if="userinfo_avatar == null || userinfo_avatar == ''" :src="userinfo_avatar1">
                      <img class="img3" v-else-if="userinfo_avatar.slice(0,5) != 'https'" :src="url + '/storage/' + userinfo_avatar">
                      <img class="img3" v-else-if="userinfo_avatar.slice(0,5) == 'https'" :src="userinfo_avatar">
                      <img class="img3" v-else src="../../../assets/home/yixiaoxing_head.png">
                      <span class="span_time3">{{ item.create_at }}</span>
                      <div class="content_message3">
                          <div v-if="item.msg_type === 'text' || item.msg_type ===''">{{ item.messages }}</div>
                          <div v-else-if="item.msg_type === 'img'">
                            <el-image  
                            :src="url + '/storage/' + item.msg_url" 
                            style="width: 100px; height: 100px"
                            :preview-src-list = "[url + '/storage/' + item.msg_url]"
                            >
                            </el-image>
                          </div>
                          <div v-else-if="item.msg_type === 'video'">
                            <video width="100%" height="100%" controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true">
                              <source :src="url + '/storage/' + item.msg_url" type="video/mp4">
                            </video>
                          </div>
                          <div v-else-if="item.msg_type === 'audio'">
                            <audio  width="100" height="40" controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true">
                              <source :src="url + '/storage/' + item.msg_url" type="audio/mp3">
                            </audio>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>

        <!-- 输入和发送 -->
        <div class="shuru">

          <div class="yi" style="display:flex">
            <div>
              <input 
                style="display:none" 
                type="file" 
                ref="imgone" 
                @change="sendPicture()" 
              >
              <img @click="clickPicture()" class="imgyi" src="../../../assets/tupian@2x.png" />
            </div>

            <div>
              <input 
                style="display:none" 
                type="file"
                ref="imgtow" 
                @change="sendVideo()" 
              >
              <img @click="clickVideo()" class="imger" src="../../../assets/shipin@2x.png" />
            </div>

            <div>
              <input 
                style="display:none" 
                type="file"
                ref="imgthree" 
                @change="sendAudio()" 
              >
              <i @click="clickAudio()" class="imgsan el-icon-headset" ></i>
            </div>

          </div>
          <!-- 输入框 -->
          <textarea class="er" placeholder="此处是输入的聊天内容" v-model="value"></textarea>
          <div class="san">
            <button @click="sendMsg($event)"><span>发送</span></button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import head from "../../common/head";
// import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  name: "chat_list",
  components: {
      'home_head':head,
  },

  data(){
    return{
      liebiao_list:[],
      liebiao_url:'',
      data_id:'',
      list_id:[],
      bianlan:0,
      keyWord:'',
      liebiao_list_new:[],
      member_a_list:[],
      member_b_list:[],
      xuiid:0,


      value: '',
      ws: null,
      accept_id: 0,
      token: null,
      list: [],
      history_list: [],
      auth_list: [],
      data_list: [],
      message: '\xa0\xa0\xa0\xa0',
      auth_img: '', //用户头像
      
      auth_username: '', //用户名
      data_img: '',//店铺头像
      url: '',
      fasong_id:'',
      me_id: '',//自己的uid
      list_history: [],//买家历史记录
      merchant_history: [],//商家历史记录
      userinfo_name:'',//对方用户名
      userinfo_avatar:'',//对方头像1
      userinfo_avatar1:'',//对方头像2
      fileData:''
    }
  },
  methods:{
    init(){
      this.get_list();
      this.liebiao_url = window.config.api_url;
    },
    //整理时间
    shijian(data){
      let moment = require('moment');
      let data_new = new Date(data).getTime()
      let now = Date.now()
      let span = (now - data_new) / 1000
      let oneDay = 3600 * 24
      let oneHour = 3600
      let oneMin = 60
      if (span > oneDay) {
        return moment(data).format('YYYY/MM/DD')
      }
      if (span <= oneDay && span >= oneHour) {
        let hours = parseInt(span / 3600)
        return hours + '小时前'
      }

      if (span < oneHour && span > oneMin) {
        let mins = parseInt(span / 3600 * 60)
        return mins + '分钟前'
      }

      if (span < oneMin && span > 0) {
        return '刚刚'
      }
    },
    //建立ws连接
    chat_room() {
        let t = this;
        t.token = localStorage.getItem('uid');
        if (t.token == null) {
          window.location.href = '/user.html'
        } else {
          t.ws = new WebSocket("wss://ws.yi-mix.com/chat/ws?id=" + t.auth_list.id);

          //监听客服端的发送
          t.ws.onopen = () => {
            console.log("建立连接成功");
            if (t.ws.readyState == 1) {
              var data = {
                  accept_id: t.fasong_id,
                  type: 1,
                  msg: '',
              };
              t.ws.send(JSON.stringify(data));
            }
          };

          //监听服务器推送
          t.ws.onmessage = function (res) {
            let resData = JSON.parse(res.data);
            if (resData.status == 201) {
              if (resData.accept_id != 0) {    //发送成功的消息
                t.list.push(resData);
                console.log("新消息",t.list)
              }           
            }
            
            if (resData.status == 200) {   //历史记录
              if (resData.accept_id != 0) {
                t.history_list.unshift(resData)         
              }           
            }
          }; 

          t.ws.onclose = () => {
            console.log("连接关闭了，重新建立连接");
            setTimeout(() => {
              t.chat_room();
            }, 1000)
          };
          t.ws.onerror = () => {
            console.log("连接出错了，重新建立连接");
            setTimeout(() => {
              t.chat_room();
            }, 1000)
          };
        }
    },
    //单击关闭按钮调用
    fanhui() {
        this.$router.go(-1);
    },
    //单击发送调用
    sendMsg(event){
      if (this.value != '') {
        var data = {
          accept_id: this.fasong_id,
          type: 2,
          msg_type  :'text',
          msg: this.value,
        };
        this.value = '';
        this.ws.send(JSON.stringify(data));
      } else {
        this.$message.warning('不能发送空消息');
      }
      if (event) {
        if (event.keyCode === 13) {   //键盘事件是enter 阻止浏览器默认的回车换行行为
          event.preventDefault();
        }
      }
      this.bianlan = 0
      this.get_chatlist();//获取左侧列表信息

    },
    //单击列表项调用
    liebiao(a,b,index){
      this.fasong_id = a
      this.me_id = b
      this.bianlan = index
      this.get_chatlist();//获取左侧列表信息
      
      this.get_history();//获取买家历史记录
      this.mer_history();//获取商家历史记录
      this.get_idlist();//获取商品信息
      this.get_userinfo();//获取对方信息
      this.list = [];
      
    },


    //获取uid
    get_list(){
      let t = this;
      let aid = localStorage.getItem('uid');
      let url = window.config.api_url + '/user/shop/info?token=' + aid;
      t.axios.get(url).then((res)=>{
        t.data_id = res.data.shop_info.uid
        t.get_chatlist()
      })

    },
    //获取左侧列表信息
    get_chatlist(){
      let t = this;
      if (document.location.protocol == 'http:'){
        let url = 'http://ws.yi-mix.com/chat/room?uid=' + this.data_id;
        t.axios.get(url).then(res=>{
          t.liebiao_list = res.data
          t.liebiao_list_new = res.data
          console.log("列表数据",res.data)
        })
      }else {
        let url1 = 'https://ws.yi-mix.com/chat/room?uid=' + this.data_id;
        t.axios.get(url1).then(res=>{
          t.liebiao_list = res.data
          t.liebiao_list_new = res.data
          console.log("列表数据",res.data)
        })
      }    
    },
    //获取买家历史记录
    get_history() {
      let t = this;
      if (document.location.protocol == 'http:'){
        let url = 'http://ws.yi-mix.com/chat/buyer/history?shopuid=' + this.fasong_id + '&uid=' + this.me_id;
        t.axios.get(url).then(res => {
          t.list_history = res.data
          t.list_history.reverse();   //将数组倒叙
          console.log(t.list_history)
        })
      }else {
        let url1 = 'https://ws.yi-mix.com/chat/buyer/history?shopuid=' + this.fasong_id + '&uid=' + this.me_id;
        t.axios.get(url1).then(res => {
          t.list_history = res.data
          t.list_history.reverse();   //将数组倒叙
          console.log(t.list_history)
        })
      }
    },
    //获取商家历史记录
    mer_history() {
      let t = this;
      if (document.location.protocol == 'http:'){
        let url = 'http://ws.yi-mix.com/chat/shoper/history?shopuid=' + this.fasong_id + '&uid=' + this.me_id;
        t.axios.get(url).then(res => {
          t.merchant_history = res.data
          t.merchant_history.reverse();
        })
      }else {
        let url1 = 'https://ws.yi-mix.com/chat/shoper/history?shopuid=' + this.fasong_id + '&uid=' + this.me_id;
        t.axios.get(url1).then(res => {
          t.merchant_history = res.data
          t.merchant_history.reverse();
        })
      }
    },
    //获取用户信息
    get_userlist() {
      let t = this;
      let aid = localStorage.getItem('uid');
      let url = window.config.api_url + '/user/info?token=' + aid;
      t.axios.get(url).then((res) => {
        t.auth_list = res.data
        if(this.auth_list!=''){
            this.chat_room();
        }
        t.auth_img = res.data.avatar  //用户头像
        t.auth_username = res.data.name //用户名
      })
    },
    //获取对方信息
    get_userinfo(){
      let t = this;
      let aid = localStorage.getItem('uid');
      let url = window.config.api_url + '/user/other/user/info/' + this.fasong_id + '?token=' + aid;
      t.axios.get(url).then(res=>{

        t.userinfo_name = res.data.name   //对方用户名
        t.userinfo_avatar = res.data.avatar   //对方头像1
        t.userinfo_avatar1 = res.data.wechat_avatar   //对方头像2     
      })
    },
    //获取商品信息
    get_idlist() {
      let t = this;
      let aid = localStorage.getItem('uid');
      let url = window.config.api_url + '/user/shop/info?token=' + aid;
      t.axios.get(url).then((res) => {
        t.data_id = res.data.shop_info.uid
        t.data_img = res.data.shop_info.shop_pic//店铺封面
      })
    },

    //单击图片调用
    clickPicture(){
      this.$refs['imgone'].click();
      console.log('click picture');
    },

    //选择图片调用
    sendPicture(){
      let imgFile = this.$refs['imgone'].files[0]; //拿到已选择的文件
      let reader = new FileReader();            //FileReader的对象用来操作目标文件/图片
      reader.onload = (e) => {                  //onload:文件读取成功时触发该函数
        this.fileData = e.target.result;        //存储图片的base64字符串到fileData中
        var data = {                            //准备数据
          accept_id : this.fasong_id,
          type      : 2,
          msg_type  :'img',
          msg       : this.fileData,
        };
        
        var told = confirm("要发送此图片吗？"); 
        if (told) { 
          this.ws.send(JSON.stringify(data));  //发送数据
        } else alert("已取消发送"); 

      }
      reader.readAsDataURL( imgFile );  //在result属性中放入图片文件的Base64字符串
      this.$refs['imgone'].value = '';
    },

    //单击视频调用
    clickVideo(){
      this.$refs['imgtow'].click();
      console.log('click Video');
    },

    //选择视频调用
    sendVideo(){
      let imgFile = this.$refs['imgtow'].files[0]; //拿到已选择的文件
      let reader = new FileReader();             //FileReader的对象用来操作目标文件/图片
      reader.onload = (e) => {                   //onload:文件读取成功时触发该函数
        this.fileData = e.target.result;         //存储图片的base64字符串到fileData中
        var data = {                             //准备数据
          accept_id : this.fasong_id,
          type      : 2,
          msg_type  :'video',
          msg       : this.fileData,
        };
        
        var told = confirm("要发送此视频吗？"); 
        if (told) { 
          this.ws.send(JSON.stringify(data));  //发送数据
        } else alert("已取消发送"); 

      }
      reader.readAsDataURL( imgFile );  //在result属性中放入图片文件的Base64字符串
      this.$refs['imgtow'].value = '';
    },

    //选择音频调用
    clickAudio(){
      this.$refs['imgthree'].click();
      console.log('click Audio');
    },

    //选择音频调用
    sendAudio(){
      let imgFile = this.$refs['imgthree'].files[0]; //拿到已选择的文件
      let reader = new FileReader();            //FileReader的对象用来操作目标文件/图片
      reader.onload = (e) => {                  //onload:文件读取成功时触发该函数
        this.fileData = e.target.result;        //存储图片的base64字符串到fileData中
        var data = {                            //准备数据
          accept_id : this.fasong_id,
          type      : 2,
          msg_type  :'audio',
          msg       : this.fileData,
        };
        
        var told = confirm("要发送此音频吗？"); 
        if (told) { 
          this.ws.send(JSON.stringify(data));  //发送数据
        } else alert("已取消发送"); 

      }
      reader.readAsDataURL( imgFile );  //在result属性中放入图片文件的Base64字符串
      this.$refs['imgthree'].value = '';
    },

  },




  //查找功能
  watch:{
    keyWord:{
      immediate:true,
      handler(val){
        this.liebiao_list_new = this.liebiao_list.filter((p)=>{
          return p.name_b.indexOf(val) !== -1 ||  p.name_a.indexOf(val) !== -1
        })
      },
    },
	}, 
  //过滤器
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 6) {
        return value.slice(0, 6) + "...";
      }
      return value;
    }
  },
  created() {
    this.init();
    this.url = window.config.api_url;
    this.me_id = this.$route.params.id; 
    this.fasong_id = this.$route.query.uid;   //对方的uid
  },
  mounted() {
      this.get_userlist();// 获取用户信息
      this.get_idlist();// 获取商品信息

      if(this.me_id!=undefined && this.fasong_id!=undefined){
        this.get_userinfo();// 获取对方信息
        this.get_history();// 获取买家历史记录
        this.mer_history();// 获取商家历史记录
      }
      
  },
  updated() {
      let el = this.$refs["msg-box"];
      el.scrollTop = el.scrollHeight;
  },
  
  
};
</script>

<style lang="less" scoped>
.wai {
  width: 860px;
  height: 600px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  position: absolute;
  top: -100px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  

  .zuoce {
    width: 240px;
    height: 600px;
    background: #ffffff;
    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.05);
    position: absolute;
    border-right: 2px solid #eaeaec;

    .mingziyi {
      width: 240px;
      height: 53px;
      border-bottom: 2px solid #eaeaec;

      img {
        width: 27px;
        height: 27px;
        margin: 13px 0px 0px 19px;
      }
      span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        margin: 8px 0px 5px 9px;
        vertical-align: bottom;
      }
    }
    .chazhao {
      width: 240px;
      height: 66px;
      button {
        width: 50px;
        height: 27px;
        background: #f2f2f2;
        box-shadow: 0px 1px 1px 0px rgba(209, 23, 23, 0.06);
        border: none;
        border-radius: 20px 0px 0px 20px;
        margin: 17px 0px 17px 17px;
        span {
          margin: 5px 0px 0px 0px;
        }
        .el-icon-search {
          font-size: 11px;
        }
      }
      input {
        width: 150px;
        height: 27px;
        background: #f2f2f2;
        box-shadow: 0px 1px 1px 0px rgba(209, 23, 23, 0.06);
        border: none;
        border-radius: 0px 20px 20px 0px;
      }
    }
    ::-webkit-scrollbar {
      width: 5px;
      background-color: #eaeaec;
    }
    ::-webkit-scrollbar-thumb {
      height: 5px;
      background-image: linear-gradient(180deg, #d0368a 0%, #708ad4 99%);
      box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
    }

    .liebiao {
      width: 240px;
      height: 480px;
      overflow: auto;
      overflow-x: hidden;
      .xuanzhong{
        background-color: #E9F3FD;
        border-left: 2px solid #2B80FF;
      }

      ul {
        position: relative;
        li {
          width: 240px;
          height: 67px;

          .tishi {
            width: 5px;
            height: 5px;
            background-color: #2dc100;
            border-radius: 100%;
            position: absolute;
            left: 10px;
            top:10px
          }
          .touxiang {
            img {
              width: 33.3px;
              height: 33.3px;
              border-radius: 100px;
            }
            position: absolute;
            left: 15px;
            top:10px
          }
          .yonghuming {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            position: absolute;
            left: 62px;
            top: 10px
          }
          .xiaoxi {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 10px;
            opacity: 0.5;
            position: absolute;
            left: 62px;
            top: 30px;
            margin-top: 10px;
          }
          .shijian {
            font-size: 7px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 26px;
            opacity: 0.2;
            position: absolute;
            left: 160px;
            top: 30px;
          }
        }
      }
    }
  }

  .youce {
    width: 620px;
    height: 600px;
    position: absolute;
    left: 240px;

    .jiedai {
      width: 620px;
      height: 53px;
      border-bottom: 2px solid #eaeaec;
      .zuo {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #0072ff;
        line-height: 25px;
        position: absolute;
        top: 15px;
        left: 20px;
      }
      .you{
        width: 25px;
        height: 25px;
        background-color: crimson;
        border-radius: 100%;
        position: absolute;
        top: 16px;
        right: 30px;


        font-size: 18px;

        line-height: 24px;
        color: #fafafa;
        text-align: center;
      }
    }
    .mingzier {
      width: 620px;
      height: 49px;
      border-bottom: 2px solid #eaeaec;
      background-color: #f9f9fb;
      span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        position: absolute;
        top: 72px;
        left: 26px;
      }
    }
    .liaotian {
      width: 620px;
      height: 300px;
      background-color: #f9f9fb;
      border-bottom: 2px solid #eaeaec;
      overflow: auto;
      overflow-x: hidden;

      .content_list {
            display: flex;

            .content_av {
                margin-top: 30px;
                margin-left: 20px;

                .content_message {
                    float: left;
                    background-color: white;
                    padding: 10px;
                    word-wrap: break-word;
                    border-radius: 0px 16px 16px 16px;
                    margin-left: 45px;
                    margin-right: 50px;
                    max-width: 450px;
                }

                .content_message1 {
                    background-color: skyblue;
                    padding: 10px;
                    border-radius: 16px 0px 16px 16px;
                    word-wrap: break-word;
                    float: right;
                    margin-top: 19px;
                    margin-right: -112.5px;
                    max-width: 450px;
                }

                .img {
                    height: 40px;
                    width: 40px;
                    border-radius: 50%;
                }

                .img1 {
                    height: 40px;
                    width: 40px;
                    float: right;
                    border-radius: 50%;
                    margin-right: 20px;
                }

                .span_time {
                    color: #8c939d;
                    display: flex;
                    margin-left: 45px;
                    margin-top: -50px;
                }

                .span_time1 {
                    float: right;
                    margin-right: 4px;
                    color: #8c939d;
                }
            }
      }

      .content_list2 {
          display: flex;
          .content_av2 {
              margin-top: 30px;
              margin-left: 20px;

              .content_message2 {
                  background-color: skyblue;
                  padding: 10px;
                  border-radius: 16px 0px 16px 16px;
                  word-wrap: break-word;
                  float: right;
                  margin-right: -112.5px;
                  margin-top: 19px;
                  max-width: 750px;
              }
              .content_message3 {
                  float: left;
                  background-color: white;
                  padding: 10px;
                  word-wrap: break-word;
                  border-radius: 0px 16px 16px 16px;
                  margin-left: 45px;
                  margin-right: 50px;
                  max-width: 750px;
              }
              .img2 {
                  height: 40px;
                  width: 40px;
                  float: right;
                  border-radius: 50%;
                  margin-right: 20px;
              }
              .img3 {
                  height: 40px;
                  width: 40px;
                  border-radius: 50%;
              }
              .span_time2 {
                  float: right;
                  margin-right: 4px;
                  color: #8c939d;
              }
              .span_time3 {
                  color: #8c939d;
                  display: flex;
                  margin-left: 45px;
                  margin-top: -50px;
              }          
          }      
      }

    }
    .shuru {
      width: 620px;
      height: 150px;
      position: relative;
      .yi {
        .imgyi {
          width: 22px;
          height: 17px;
          position: relative;
          top: 14px;
          left: 22px;
        }
        .imger {
          width: 22px;
          height: 17px;
          position: relative;
          top: 14px;
          left: 34px;
        }
        .imgsan {
          font-size: 20px;
          position: relative;
          top: 12px;
          left: 45px;
        }
      }
      .er {
        position: relative;
        top: 20px;
        left: 20px;
        width: 500px;
        height: 100px;
        border: none;
        resize: none;
      }
      .san {
        button {
          width: 90px;
          height: 30px;
          background-color: #0084ff;
          border: none;
          border-radius: 30px;
          position: relative;
          top: 30px;
          left: 508px;
          span {
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>